import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
export const ContentColumn = styled(Box)({
    flexGrow: 1,
});

export const ContentHeaderWrapper = styled(Box)(({ theme }) => ({
    display: 'none',
    [theme.breakpoints.up('md')]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingBottom: '15px',
        marginBottom: '20px',
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
}));

export const ContentHeaderTitle = styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 500,
}));